import { Outlet, useMatches } from "react-router";
import { AuthProvider } from "../contexts/authContext";
import LoginPromptProvider from "../contexts/LoginPromptContext";
import { Helmet } from "react-helmet-async";
import { PremiumModalProvider } from "../components/premium-modal/PremiumModalProvider";
import { NotificationProvider } from "../contexts/NotificationContext";
import { AIQuizUsageProvider } from "../contexts/AIQuizUsageContext";

function RootLayout() {
  const matches = useMatches();

  // get the deepest matched route
  const lastMatch = matches[matches.length - 1];
  const title = lastMatch?.handle?.title || "Examsprep";

  return (
    <AuthProvider>
      <NotificationProvider>
        <div className="min-h-screen bg-base-200">
          {/* dynamically set the page title based on route meta */}
          <Helmet>
            <title>{title}</title>
          </Helmet>

          <LoginPromptProvider>
            <PremiumModalProvider>
              <AIQuizUsageProvider>
                <Outlet />
              </AIQuizUsageProvider>
            </PremiumModalProvider>
          </LoginPromptProvider>
        </div>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default RootLayout;
